// extracted by mini-css-extract-plugin
export default {"crbtn-context":"style_crbtn-context__iIIGT","selected":"style_selected__ZX7iz"};